<template>
	<div class="review-option">
		<!-- 审核意见列表 -->
		<div class="list" v-if="reviewOpinionList.length>0">
			<div class="comments-list" v-for="(item, index) in reviewOpinionList" :key="index">
				<div class="form-group row mb-2">
					<label class="col-md-2 col-12 col-form-label" style="text-align: right;">{{getReviewTitle(item.auditType,index+1)}}</label>
					<div class="col-md-9 col-10">
						<table class="table table-bordered table-centered mb-0">
							<tbody>
								<tr>
									<th>审核意见</th>
									<td>{{item.auditState == 0?'退回修改':item.auditState == 1?'通过':'不通过'}}</td>
									<th>审核人</th>
									<td>{{item.auditName}}</td>
									<th>审核时间</th>
									<td>{{item.createTime}}</td>
								</tr>
								<tr>
									<th>审核说明</th>
									<td colspan="5">{{item.auditExplain}}</td>
								</tr>
							</tbody>
						</table>
					</div>
					<div class="col-md-1 col-2"><span class="required"></span></div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import { TopicDeclarationDetail } from '@/api/after/schoolAudit.js';
	export default {
		data(){
			return {
				reviewOpinionList:[]
			}
		},
		computed:{
			// 获取评审意见标题
			getReviewTitle(auditType,index){
				return (auditType,index) => {
					if (auditType==0) {
						return '校审意见'+index
					}else{
						return '区审意见'+index
					}
				}
			}
		},
		created() {
			let id = this.$route.query.id
			if (id) {
				this.getReviewOpinion(id)
			}
		},
		methods:{
			async getReviewOpinion(id){
				const res = await TopicDeclarationDetail(id)
				if (res.code == 200) {
					this.reviewOpinionList = res.data.schoolAuditList
					console.log('123',res);
				}else{
					this.$message.error(res.data)
				}
			}
		}
	}
</script>

<style scoped lang="scss">
.list{
	margin-top: 20px;
}
</style>